import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export function getUserIfExists() {
  const user = localStorage.getItem('user');
  return user ? user : null;
}

const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
  let [user, setUser] = React.useState(getUserIfExists);

  useEffect(() => {
    if (user == null) {
      localStorage.removeItem('user');
    } else if (!getUserIfExists()) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }, [user]);

  return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  userData: PropTypes.any,
  children: PropTypes.any,
};

export const useAuth = () => React.useContext(AuthContext);
